import ChargeService from '@/services/ChargeService'
import makePurchaseService from '@/providers/PurchaseServiceProvider';

const state = {
    transactionId: null,
    status: null,
    error: false,
}

const actions = {
    purchaseFailed({ commit }, error) {
        commit('ERROR', error)
    },

    async createChargeWithUuid({ commit }, { vendor, uuid, plan, access_token }) {
        const chargeService = makePurchaseService(vendor, access_token)

        commit('SET', null)

        return chargeService.chargeWithUuid({
            uuid,
            plan,
        })
            .then((response) => {
                if (response.status === 201) {
                    const { transactionId } = response.data
                    commit('SET', transactionId)
                }
                return response
            })
            .catch((error) => error)
    },

    async createChargeWithPhoneNumber({ commit }, { vendor, userId, msisdn, plan, access_token, uvid, paymentMethod }) {
        const chargeService = makePurchaseService(vendor, access_token)

        commit('SET', null)

        const chargePromise = plan.type === 'Rental'
            ? chargeService.chargeWithMsisdn({ userId, msisdn, plan: plan.external_id, productName: plan.name, uvid, paymentMethod })
            : chargeService.chargeWithMsisdn({ userId, msisdn, plan: plan.external_id, productName: plan.name, paymentMethod })

        return chargePromise
            .then((response) => {
                if (response.status === 201) {
                    const { transactionId } = response.data
                    commit('SET', transactionId)
                }
                return response
            })
    },

    async cancel({ commit }, { access_token, subscriptionId, msisdn }) {
        const chargeService = new ChargeService(access_token)

        commit('SET', null)

        return chargeService.cancel({
            subscriptionId,
            msisdn,
        })
            .then((response) => response.status === 200)
    },

    resetErrors({ commit }) {
        commit('ERROR', false)
    },
    // eslint-disable-next-line no-unused-vars
    checkStatus({ commit }, { vendor, transactionId, msisdn, access_token }) {
        const chargeService = makePurchaseService(vendor, access_token)

        let status = null

        commit('ERROR', false)

        const check = () => {
            chargeService.check({ transactionId, msisdn })
                .then((response) => {
                    status = response.data.status
                })
        }

        check()

        const loop = setInterval(() => {
            check()

            if (status && status !== 'PENDING') {
                clearInterval(loop)
            }

            if (status && status === 'ACCEPTED') {
                commit('ACCEPTED', status)
            }

            if (status && status === 'REJECTED') {
                commit('ERROR', 'purchase_rejected')
            }
        }, (1000 * 4))

        setTimeout(() => {
            clearInterval(loop)
            commit('ERROR', 'purchase_timeout')
        }, (1000 * 60 * 2))
    },
    reset({ commit }) {
        commit('SET', null)
        commit('ACCEPTED', null)
        commit('ERROR', false)
    },
}

const mutations = {
    SET(state, transactionId) {
        Object.assign(state, { transactionId })
    },
    ACCEPTED(state, status) {
        state.status = status
    },
    ERROR(state, error) {
        state.error = error
    },
    LOG(state, res) {
        console.log(res)
    },
}

const getters = {
    id(state) {
        if (state.transactionId) {
            return state.transactionId
        }

        return false
    },
    error(state) {
        return state.error
    },
    status(state) {
        return state.status
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
